import { ViewportScroller } from '@angular/common'
import { NgModule } from '@angular/core'
import { NavigationEnd, Router, RouterModule, Scroll } from '@angular/router'
import { filter, pairwise } from 'rxjs'

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot([], {
      initialNavigation: 'enabledBlocking',
      anchorScrolling: 'enabled'
    })
  ]
})
export class AppRoutingModule {
  constructor(
    private readonly router: Router,
    private readonly viewportScroller: ViewportScroller
  ) {
    this.router.events
      .pipe(
        filter(e => e instanceof Scroll),
        pairwise()
      )
      .subscribe(eventPair => {
        const previousEvent = eventPair[0] as Scroll
        const event = eventPair[1] as Scroll
        if (event.position) {
          // backward navigation
          this.viewportScroller.scrollToPosition(event.position)
        } else if (event.anchor) {
          // anchor navigation
          this.viewportScroller.scrollToAnchor(event.anchor)
        } else {
          if (
            previousEvent.routerEvent instanceof NavigationEnd &&
            event.routerEvent instanceof NavigationEnd &&
            previousEvent.routerEvent.urlAfterRedirects.split('?')[0] !==
              event.routerEvent.urlAfterRedirects.split('?')[0]
          ) {
            // Routes don't match -> forward navigation
            this.viewportScroller.scrollToPosition([0, 0])
          }
        }
      })
  }
}
